import {
  UpdateLendUserRemindRequestCollection,
  UpdateLendUserRemindRequestCollectionToJSON
} from '@/api'

export interface UpdateLendUserRemindRequest {
  id: string
  collections: UpdateLendUserRemindRequestCollection[]
  reminderMethod: number
  reminderType: string
  reminderName: string
  reminderMemo: string
}

export function UpdateLendUserRemindRequestToJSON(
  value: UpdateLendUserRemindRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    collections:
      value.collections.length > 0
        ? value.collections.map(UpdateLendUserRemindRequestCollectionToJSON)
        : undefined,
    reminder_method:
      value.reminderMethod !== 0 ? value.reminderMethod : undefined,
    reminder_type: value.reminderType !== '' ? value.reminderType : undefined,
    reminder_name: value.reminderName !== '' ? value.reminderName : undefined,
    reminder_memo: value.reminderMemo !== '' ? value.reminderMemo : undefined
  }
}
